import type { GuidedExperienceDefinition } from './guidedExperienceRegistry';
import Slide1AssessmentComplete from './welcome-tour/slides/Slide1AssessmentComplete';
import Slide2AssessmentHighlights from './welcome-tour/slides/Slide2AssessmentHighlights';
import Slide3PositiveThemes from './welcome-tour/slides/Slide3PositiveThemes';
import Slide4GrowthOpportunities from './welcome-tour/slides/Slide4GrowthOpportunities';
import Slide3CultureDimensions from './welcome-tour/slides/Slide5CultureDimensions';
import Slide6OrganizationalComparison from './welcome-tour/slides/Slide6OrganizationalComparison';
import Slide5NextSteps from './welcome-tour/slides/Slide7NextSteps';
import Slide8Ready from './welcome-tour/slides/Slide8Ready';

export const welcomeTourExperience: GuidedExperienceDefinition = {
  id: 'welcome-tour',
  title: 'Welcome to nuLogic',
  version: '2.0.0',
  priority: 100,
  steps: [
    {
      id: 'welcome',
      title: "Welcome to nuLogic",
      component: Slide1AssessmentComplete,
    },
    {
      id: 'team-story',
      title: "Assessment Complete",
      component: Slide2AssessmentHighlights,
    },
    {
      id: 'positive-themes',
      title: 'Positive Themes',
      component: Slide3PositiveThemes,
    },
    {
      id: 'growth-opportunities',
      title: 'Growth Opportunities',
      component: Slide4GrowthOpportunities,
    },
    {
      id: 'culture-dimensions',
      title: 'Organizational Comparison',
      component: Slide3CultureDimensions,
    },
    {
      id: 'culture-profile',
      title: 'Your Culture Profile',
      component: Slide6OrganizationalComparison,
    },
    {
      id: 'next-steps',
      title: 'Where Should You Start?',
      component: Slide5NextSteps,
    },
    {
      id: 'ready',
      title: "You're Ready",
      component: Slide8Ready,
    },
  ],
};
